// Initialise Slick slider

( function( $, window, document, undefined ) {

	// Uncomment to use SVG icon buttons
	// const prevArrowHTML = `<button type="button" class="slick-prev" aria-label="Previous slide"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.88 25.99" aria-hidden="true" focusable="false"><path d="M14.37.51a1.74,1.74,0,0,0-2.45,0h0L.41,12a1.38,1.38,0,0,0,0,2h0l11.5,11.51A1.74,1.74,0,1,0,14.37,23l-10-10,10-10A1.73,1.73,0,0,0,14.37.51Z"/></svg></button>`;
	// const nextArrowHTML = `<button type="button" class="slick-next" aria-label="Next slide"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.88 25.99" aria-hidden="true" focusable="false"><path d="M.51,25.48a1.74,1.74,0,0,0,2.45,0H3L14.47,14a1.38,1.38,0,0,0,0-2h0L3,.51A1.73,1.73,0,0,0,.51,3l10,10L.5,23A1.73,1.73,0,0,0,.51,25.48Z"/></svg></button>`;

	const defaultArgs = {
		autoplay: false,
		dots: false,
		arrows: true,
		// prevArrow: prevArrowHTML,
		// nextArrow: nextArrowHTML,
		infinite: true,
		adaptiveHeight: false,
		draggable: false
	};

	const $carousel = $('.plans__carousel');

	if ( $carousel.length ) {

		// Run on a specific selector with default args
		$carousel.slick({
			arrows: false,
			dots: true,
			infinite: true,
			adaptiveHeight: false,
			draggable: false,
			vertical: true,
			asNavFor: '.plans__titles',
			responsive: [
			    {
			      breakpoint: 1259,
			      settings: {
			        vertical: false,
			        draggable: true
			      }
			    }
			  ]
		});

		$('.plans__titles').slick({
			arrows: false,
			dots: false,
			fade: true,
			draggable: false,
			asNavFor: $carousel
		});

	} // /$carousel.length

	// var $headlines = $('.headline_carousel');

	// if ( $headlines.length ) {
	// 	$headlines.slick({
	// 		arrows: false,
	// 		dots: false,
	// 		adaptiveHeight: false,
	// 		draggable: false,
	// 		autoplay: true,
	// 		autoplaySpeed: 3000,
	// 		pauseOnHover: false,
	// 		infinite: true
	// 	});
	// }

	// var $allDrips = $headlines.find('.drip');

	// $headlines.on('afterChange', function() {

	// 	var $currentSlide = $headlines.find('.slick-current');

	// 	$allDrips.each( function() {
	// 		$(this).removeClass('animate');
	// 	});

	// 	$currentDrips = $currentSlide.find('.drip');
	// 	$currentDrips.each( function () {
	// 		$(this).addClass('animate');
	// 	});
	// });


	let $imageCarousel = $('.js-image-carousel');

	if ( $imageCarousel.length ) {
		$imageCarousel.slick( {
			autoplay: true,
			autoplaySpeed: 2000,
			dots: true,
			arrows: false,
			infinite: true,
			adaptiveHeight: false,
			draggable: true
		} );

		// add class that hides focus outline if clicking instead of keyboard tabbing
		$imageCarousel.find('.slick-dots button')
			.on('click', function(event) {
				$imageCarousel.find('.slick-dots').addClass('not-focus-visible');
			})
			.on('blur', function(event) {
				$imageCarousel.find('.slick-dots').removeClass('not-focus-visible');
			});
	}

} )( jQuery, window, document );
